export const useCustomerUserAgeValidationConstants = () => {
    const minimalAge = 18;
    const maximalAge = 120;
    const currentDate = new Date();

    const maximalDate = new Date(currentDate.getFullYear() - minimalAge, currentDate.getMonth(), currentDate.getDate());

    const minimalDate = new Date(maximalDate.getFullYear() - maximalAge, maximalDate.getMonth(), maximalDate.getDate());

    return {
        minimalAge,
        minimalDate,
        maximalDate,
    };
};
